export enum JenzPermissions {
  SuperAdmin = 'ROLE_ADMIN_SUPERUSER',
  Admin = 'ROLE_ADMIN',
  User = 'ROLE_USER',
  JenzSupport = 'ROLE_SUPPORT',
  Statistics = 'ROLE_ADMIN_STATISTICS',
  Users = 'ROLE_ADMIN_USERS',
  Departments = 'ROLE_ADMIN_DEPARTMENTS',
  Groups = 'ROLE_ADMIN_GROUPS',
  Stories = 'ROLE_ADMIN_STORIES',
  Surveys = 'ROLE_ADMIN_SURVEYS',
  Quiz = 'ROLE_ADMIN_QUIZZES',
  Documents = 'ROLE_ADMIN_DOCUMENTS',
  Kudos = 'ROLE_ADMIN_CLAPS',
  Notifications = 'ROLE_ADMIN_NOTIFICATIONS',
  Settings = 'ROLE_ADMIN_SETTINGS',
  Shouts = 'ROLE_ADMIN_SHOUTS',
}
